<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="introduction">
<h1>Introduction</h1>
<p>Hello, reader. My name is George Thomas Knowlson-Baker.</p>
<p>I am a porter at Southmead Hospital in the City of Bristol.</p>
<p>In this book, we are looking back at the world. Reviewing how the COVID-19 virus has had an impact. What my own experiences are and what I have done to get out of life during everything.</p>
<p>Hopefully, you can relate to the subject and find something to pass on yourself to someone else, after watching all the loss of life during this era of disease.</p>
<p>We all have a story to tell and this one is mine.</p>
<p>So get ready to enter into our tale of life and wonder.</p>
<p>The COVID-19 life book is about my own experience and impact on those around me during this pandemic.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?65c59100